import axios from 'axios';
import { paymentEnum } from '@/constant/payment-info';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_PAY_LATER}`;

export const fetchZingala = () => axios.get(API_PATH, { params: { paymentType: paymentEnum.ZingalaPayment } });
